import { render, staticRenderFns } from "./ReportLawyers.vue?vue&type=template&id=0e2edb0c"
import script from "./ReportLawyers.vue?vue&type=script&lang=js"
export * from "./ReportLawyers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports